import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PopulationTrendChart = ({ data, title }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 shadow-conservation border border-[var(--color-border)]">
      <h3 className="text-xl font-semibold text-[var(--color-foreground)] mb-6">{title}</h3>
      <div className="w-full h-80" aria-label={`${title} Line Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="year" 
              stroke="var(--color-muted-foreground)"
              tick={{ fill: 'var(--color-foreground)' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              tick={{ fill: 'var(--color-foreground)' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)', 
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                color: 'var(--color-foreground)'
              }}
              labelStyle={{ color: 'var(--color-foreground)' }}
            />
            <Legend 
              wrapperStyle={{ color: 'var(--color-foreground)' }}
              iconType="circle"
            />
            <Line 
              type="monotone" 
              dataKey="population" 
              stroke="var(--color-primary)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', r: 4 }}
              activeDot={{ r: 6 }}
              name="Population Count"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PopulationTrendChart;